// AI Generated Test
import { Component, Input, Output, EventEmitter, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'pages-button',
    templateUrl: './pages-button.component.html',
    styleUrls: ['./pages-button.component.scss'],
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PagesButtonComponent),
            multi: true,
        },
    ],
})
export class PagesButtonComponent implements OnInit, ControlValueAccessor {
    @Input() monAriaLabel?: string | undefined;
    @Input() text?: string | undefined;
    @Input() textPlural?: string | undefined;
    @Output() callback = new EventEmitter<void>();

    model: number = 0;
    label: string = '';
    private onChange = (value: number) => {};
    private onTouched = () => {};

    constructor (private translateService: TranslateService) {}

    // ControlValueAccessor implementation
    writeValue (value: number): void {
        this.model = value || 0;
        this.updateLabel();
    }

    registerOnChange (fn: (value: number) => void): void {
        this.onChange = fn;
    }

    registerOnTouched (fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState? (isDisabled: boolean): void {
        // Implementation if needed for disabled state
    }

    ngOnInit (): void {
        this.text = this.text || this.translateService.getString('page');
        this.textPlural = this.textPlural || this.translateService.getString('pages');
        this.updateLabel();
    }

    private updateLabel (): void {
        if (this.monAriaLabel) {
            const count = this.parseModel();
            const displayText = count === 1 ? this.text : this.textPlural;
            this.label = this.monAriaLabel + ' ' + count + ' ' + displayText;
        }
    }

    parseModel (): number {
        return parseInt(String(this.model)) || 0;
    }

    onCallback (): void {
        this.onTouched();
        this.callback.emit();
    }
}
